
import React from 'react';
import { SectionsActionButtons } from "./SectionsActionButtons";
import { SectionsGrid } from "./SectionsGrid";
import { EditSectionDialog } from "./EditSectionDialog";
import { DeleteSectionDialog } from "./DeleteSectionDialog";
import { AddSectionDialog } from "./AddSectionDialog";
import { WebhookDialog } from "./WebhookDialog";
import { useSectionsManager } from "@/hooks/useSectionsManager";
import { SectionsManagerProps } from "@/types/sections";

export const SectionsManager = ({
  sections,
  onSectionsChange,
  webhookConfig,
  onWebhookConfigChange
}: SectionsManagerProps) => {
  const {
    editDialogOpen,
    setEditDialogOpen,
    deleteDialogOpen,
    setDeleteDialogOpen,
    addDialogOpen,
    setAddDialogOpen,
    webhookDialogOpen,
    setWebhookDialogOpen,
    selectedSection,
    handleDragEnd,
    handleEditCard,
    handleDeleteCard,
    handleEditSave,
    handleDeleteConfirm,
    handleAddSection,
    handleWebhooksClick,
    handleWebhookSave,
  } = useSectionsManager({
    sections,
    onSectionsChange,
    webhookConfig,
    onWebhookConfigChange
  });

  const handleAddSectionClick = () => {
    console.log('Add section button clicked');
    setAddDialogOpen(true);
  };

  return (
    <div className="space-y-6">
      <SectionsActionButtons
        onAddSection={handleAddSectionClick}
        onWebhooksClick={handleWebhooksClick}
      />

      <SectionsGrid
        sections={sections}
        onSectionsChange={onSectionsChange}
        onEditCard={handleEditCard}
        onDeleteCard={handleDeleteCard}
        onDragEnd={handleDragEnd}
      />

      <EditSectionDialog
        open={editDialogOpen}
        onOpenChange={setEditDialogOpen}
        section={selectedSection}
        onSave={handleEditSave}
      />

      <DeleteSectionDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        section={selectedSection}
        onConfirm={handleDeleteConfirm}
      />

      <AddSectionDialog
        open={addDialogOpen}
        onOpenChange={setAddDialogOpen}
        onSave={handleAddSection}
      />

      <WebhookDialog
        open={webhookDialogOpen}
        onOpenChange={setWebhookDialogOpen}
        initialConfig={webhookConfig}
        onSaveConfig={handleWebhookSave}
      />
    </div>
  );
};
